var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkModeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9562 15.1359C16.4234 14.8673 14.8947 13.7416 13.9736 12.0223C12.8847 9.98963 12.9628 7.72039 14.0142 6.27944C14.122 6.13175 14.24 5.99276 14.368 5.86362C14.6149 5.61455 14.5435 5.14979 14.1963 5.09307C13.9699 5.05608 13.7399 5.02981 13.5067 5.01481C13.354 5.00499 13.2 5 13.0447 5C9.15403 5 6 8.13401 6 12C6 15.866 9.15403 19 13.0447 19C15.2587 19 17.2342 17.9852 18.5256 16.3981C18.6724 16.2178 18.8103 16.0301 18.9387 15.8356C19.1217 15.5585 18.8679 15.2066 18.5345 15.1961C18.3425 15.19 18.1493 15.1697 17.9562 15.1359Z",
    stroke: "#0D2E5A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIcon);
export default __webpack_public_path__ + "static/media/dark-mode-icon.b454819fcb89b62d4129c9109f9a3d94.svg";
export { ForwardRef as ReactComponent };